export default __webpack_public_path__ + "static/kb_2_9-7a340c284506593937eaedf9af1cacd3.jpg";